export function getRange(rangeLength: number) {
    return Array.from(Array(rangeLength).keys()).map(k => k + 1);
}